export const isLayoutNode = (nodeID: string, layoutNodesIds: string[]): boolean => {
  return layoutNodesIds.some(item => item === nodeID);
};
